import { UserPostRequestBody, UserPostResponse } from '@lio/api-types';
import { userQueryKey } from '@services/user/keys';
import { useQueryClient, useMutation } from '@tanstack/react-query';
import { useClient } from '@utils/api-client';

export const useCreateUser = () => {
  const queryClient = useQueryClient();
  const client = useClient();
  const mutationFn = async (requestBody: UserPostRequestBody) => {
    const url = 'user';
    const res = await client.post(url, {
      json: requestBody,
    });
    return res.json<UserPostResponse>();
  };
  const result = useMutation({
    mutationFn,
    onSuccess: (data) => {
      queryClient.invalidateQueries({
        queryKey: userQueryKey.search,
      });
      queryClient.invalidateQueries({
        queryKey: userQueryKey.getWithParams(data.id),
      });
    },
  });
  return { ...result, createUser: result.mutateAsync };
};
